module.exports = __webpack_public_path__ + "static/media/Diners.386ce000.svg";